import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'

// Services

// Components
import { Loader } from 'components/Loader/Loader'
import { usePageTitle } from 'context/pageTitleContext'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import { useDebounce } from 'helpers/hooks'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { MediaItemPlaylist } from 'pages/media/components/MediaItemPlaylist/'
import { getMediaAutocomplete, getPlaylists } from 'services/endpoints/media'
import { type IPlaylist } from 'types/interfaces/ITypes'

// Styling
import styles from './playlists.module.scss'

export const Playlists = () => {
    const [autocompleteTerm, setAutocompleteTerm] = useState<string>('')
    const [searchTerm, setSearchTerm] = useState<string>('')
    const { t } = useTranslation()
    const { setTitle } = usePageTitle()
    const navigate = useNavigate()

    const debouncedAutocompleteTerm = useDebounce(autocompleteTerm, 500)

    const { data: autocompleteResults } = useQuery(
        ['getMediaAutocomplete', debouncedAutocompleteTerm],
        async () =>
            await getMediaAutocomplete({
                searchTerm: debouncedAutocompleteTerm
            }),
        { enabled: !!debouncedAutocompleteTerm }
    )

    const { data, status } = useQuery(
        ['getPlaylists', searchTerm],
        async () => await getPlaylists(searchTerm),
        {
            refetchOnWindowFocus: false,
            staleTime: 10000
        }
    )
    useEffect(() => {
        setTitle('Playlists')
    }, [setTitle])

    return (
        <div className='media__content__wrapper'>
{/*             <WithHeaderSection
                headerSection={
                    <LayoutHeader
                        type='search-with-buttons'
                        searchValue={autocompleteTerm}
                        searchFn={(term: string) => {
                            setAutocompleteTerm(term)
                        }}
                        clearFn={() => {
                            setSearchTerm('')
                        }}
                        additionalProps={{ placeholder: t('searchPlaylists') }}
                        buttons={[]}
                        selectFn={(value: string) => {
                            setSearchTerm(value)
                            setAutocompleteTerm('')
                        }}
                        mediaSearchResults={autocompleteResults}
                    />
                }
            > */}
                <div className={styles.wrapper}>
                    <div className={styles.content}>
                        {status === 'loading' ? (
                            <div className={styles.loader}>
                                <Loader />
                            </div>
                        ) : (
                            <>
                                {data &&
                                    !!data.length &&
                                    data.map((playlist: IPlaylist) => (
                                        <MediaItemPlaylist
                                            key={playlist.playlist_info.id}
                                            playlistData={playlist}
                                            active={false}
                                            setIsActive={() => {
                                                navigate(
                                                    `/playlists/${playlist.playlist_info.id}`
                                                )
                                            }}
                                            customClass='customPlaylistsFeed'
                                        />
                                    ))}
                            </>
                        )}
                    </div>
                </div>
            {/* </WithHeaderSection> */}
        </div>
    )
}
